import { FC } from "react";
import "./style.scss";
import { ReactComponent as Image } from "../../../../assets/icon-image.svg";
import { ReactComponent as Camera } from "../../../../assets/icon-camera.svg";
import { ReactComponent as Trash } from "../../../../assets/icon-trash.svg";
import { useTranslation } from "react-i18next";

type PropType = {
  onClose: () => void;
  onGalleryClick: () => void;
  onCameraClick: () => void;
  onRemoveClick: () => void;
  remove: boolean;
};

export const EditProfilePhoto: FC<PropType> = ({
  onClose,
  onGalleryClick,
  onCameraClick,
  onRemoveClick,
  remove,
}) => {
  const { t } = useTranslation("app");
  return (
    <div className="bottom-sheet-modal-wrapper">
      <div onClick={onClose} className="outlet-edit-profil-img"></div>

      <div className="edit-profil-img">
        <div className="edit-profil-img-header">
          <p>{t("editProfilePhoto")}</p>
        </div>

        <div onClick={onGalleryClick} className="edit-profile-row">
          <Image className="edit-profile-row-icon" aria-hidden />
          <p>{t("gallery")}</p>
        </div>

        <div onClick={onCameraClick} className="edit-profile-row">
          <Camera className="edit-profile-row-icon" aria-hidden />
          <p>{t("camera")}</p>
        </div>

        {remove === true && (
          <div onClick={onRemoveClick} className="edit-profile-row">
            <Trash className="edit-profile-row-icon" aria-hidden />
            <p>{t("removePhoto")}</p>
          </div>
        )}
      </div>
    </div>
  );
};
